<template>
  <div
    class="couponContainer"
    v-if="couponList.length"
  >
    <div class="couponTop"></div>
    <div class="couponTitle"></div>
    <div
      class="time"
      v-if="djs"
    >
      <span class="timeDate">{{djs.dd}}</span>
      <span class="today">天</span>
      <span class="timeDate">{{djs.hh}}</span>
      <span class="colon">:</span>
      <span class="timeDate">{{djs.mm}}</span>
      <span class="colon">:</span>
      <span class="timeDate">{{djs.ss}}</span>
    </div>
    <div class="couponMain"  @click="onClickGetCouon">
      <img
        :src="couponList[0].images"
        alt=""
        class="couponBg"
      >
      <!-- <div
        class="hideContainer"
      ></div> -->
    </div>
    <commonLoading v-show="loading" />
  </div>
</template>

<script>

import { mapState } from 'vuex';
import _ from 'lodash';
import { replaceHyphens } from '@/utils/tools';
import { reqReceiveCoupon } from '@/api/coupon/index';
import commonLoading from '@/components/commonComponents/CommonLoading.vue';
import { homeGioAdClick } from '@/utils/tools';
export default {
  props: {
    examType: {
      type: Number,
      default: 23,
    },
    couponadvertList: {
      type: Array,
      default: null,
    },
  },
  components: {
    commonLoading,
  },
  data() {
    return {
      djs: null,
      couponList: [],
      loading: false,
    };
  },
  computed: {
    ...mapState(['userInfo']),
  },

  mounted() {
    // this.SETINTERVAL()
  },
  watch: {
    userInfo: {
      deep: true,
      handler() {
        // this.onClickGetCouon();
      },
    },
    couponadvertList(val) {
      if (val?.length > 0) {
        val[0].adPosition_var = `${this.examType}考研-首页-优惠券广告`
        this.couponList = new Array(val[0]);
        this.SETINTERVAL();
      }
    },
  },
  methods: {
    SETINTERVAL() {
      this.clearIntervalTimer();
      this.times = setInterval(() => {
        const {
          endTime,
        } = this.couponList[0];
        const endTimes = new Date(replaceHyphens(endTime)).getTime();
        const nowtime = new Date().getTime();
        const rightTime = endTimes - nowtime;
        if (rightTime > 0) {
          const dd = Math.floor(rightTime / 1000 / 60 / 60 / 24);
          const hh = Math.floor((rightTime / 1000 / 60 / 60) % 24);
          const mm = Math.floor((rightTime / 1000 / 60) % 60);
          const ss = Math.floor((rightTime / 1000) % 60);
          // eslint-disable-next-line no-param-reassign
          this.djs = {
            dd: dd.toString().padStart(2, '0'),
            hh: hh.toString().padStart(2, '0'),
            mm: mm
              .toString()
              .padStart(2, '0'),
            ss: ss.toString().padStart(2, '0'),

          };
        } else {
          this.couponList = [];
          this.clearIntervalTimer();
        }
      }, 1000);
    },

    // 领取优惠券
    onClickGetCouon() {
      homeGioAdClick(this.couponList); // gio
      this.loading = true;
      const userId = this.userInfo.id;
      if (userId) {
        _.debounce(this.handleGetCouon(), 300);
        return;
      }
      const paths = +this.examType === 23 ? '/home' : '/exam24';
      this.$router.push({
        path: '/registrationLogin',
        query: { redirect: paths },
      });
    },
    async handleGetCouon() {
      if (!this.times) {
        this.loading = false;
        this.$toast('优惠券未在领取时间范围内');
        return;
      }
      // if (!availableStock) {
      //   this.$toast('优惠券已领完');
      //   return
      // }

      const res = await reqReceiveCoupon({
        couponId: String(this.couponList[0].productId),
        // couponVersion: Number(item.couponVersion),
        isLink: 0,
        fitPlatform: 1,
        fitEndPoint: this.$root.$data.isApp ? 2 : 4,
        terminalMark: this.$global.terminalMark
      });

      this.loading = false;
      if (res.code === 0) {
        this.$toast('领取成功');
      } else {
        this.$toast(res.msg);
      }
    },

    clearIntervalTimer() {
      clearInterval(this.times);
      this.times = null;
    },
  },

  beforeDestroy() {
    this.clearIntervalTimer();
  },
};
</script>

<style lang="scss" scoped>
.couponContainer {
  position: relative;
  width: 100%;
  height: 276px;
  background: linear-gradient(360deg, #fff 0%, #fcede6 100%);

  .couponTop {
    position: absolute;
    top: 0;
    right: 0;
    width: 364px;
    height: 164px;
    background-image: url(https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/home/homeCouponBg.png);
    background-size: contain;
  }

  .couponTitle {
    position: absolute;
    top: 32px;
    left: 40px;
    width: 166px;
    height: 40px;
    background-image: url(https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/home/homeCouponTitle.png);
    background-size: contain;
  }

  .time {
    position: absolute;
    top: 40px;
    left: 228px;
    height: 40px;
    color: #111;
    font-size: 24px;

    .timeDate {
      padding: 4px;
      color: #fff;
      text-align: center;
      background: #ff3938;
      border-radius: 8px;
    }
    .today {
      margin: 0 8px;
    }

    .colon {
      margin: 0 4px;
    }
  }

  .couponMain {
    position: absolute;
    bottom: 32px;
    left: 40px;
    width: 670px;
    height: 140px;
    text-align: center;
    // background-image: url(https://ark-test-cdn-images.iqihang.com/image/20221013/cce92f82dd4546c087ca60416fbf7819.png);
    // background-size: contain;
    border-radius: 8px;

    img {
      width: 670px;
      height: 140px;
    }

    // .hideContainer {
    //   position: absolute;
    //   top: 0;
    //   right: 0;
    //   width: 220px;
    //   height: 140px;
    //   opacity: 0;
    // }
  }
}
</style>
